import { StepProps, Steps } from 'antd';
import { MasterSubCategory } from 'domain/entities/MasterEntity';
import { PurchaseDefaultEntity } from 'domain/entities/PurchaseEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import {
    completeFetching,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { PurchaseStepOne } from './components/PurchaseStepOne';
import { PurchaseStepThree } from './components/PurchaseStepThree';
import { PurchaseStepTwo } from './components/PurchaseStepTwo';

const items: StepProps[] = Array.from(Array(3).keys()).map(() => {
    return {};
});

const MASTER_GROUP_CODES = [
    MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION,
];

export const NUMBER_MULTIPLE_DEPOSIT = 100000;

const CU01501Page = (props: AppProps) => {
    const [searchParams] = useSearchParams();
    const purchaseOfferId = searchParams.get('purchaseOfferId') || '';
    const listedPropertyId = searchParams.get('listedPropertyId') || '';
    const procedureId = searchParams.get('procedureId') || '';
    const purchasePrice = searchParams.get('purchasePrice') || '';
    const loanUseStatus = searchParams.get('loanUseStatus') || '';
    const simId = searchParams.get('simId') || '';
    const step = searchParams.get('step') || '';
    const [isInit, setIsInit] = useState(true);

    const dispatch = useAppDispatch();

    const [current, setCurrent] = useState(0);

    const [masterData, setMasterData] = React.useState<any>();
    const [data, setData] = React.useState<PurchaseDefaultEntity>();
    const [offerId, setOfferId] = useState(purchaseOfferId);
    const [isChange, setIsChange] = useState<boolean>(false);

    const { masterUseCase, purchaseUseCase } = props;

    useEffect(() => {
        (async () => {
            if (step) {
                setCurrent(Number(step) - 1);
            }
            await Promise.all([initiateDefaultData(Number(step) - 1), initiateOptions()]);
        })();
    }, []);

    const initiateOptions = async () => {
        try {
            dispatch(startFetching());
            const options = await masterUseCase.getMasterSubCategoryGroupList({
                categoryCodes: MASTER_GROUP_CODES,
            });
            const masterDataInit: any = {
                ...options,
            };
            masterDataInit[MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
            ]
                ?.filter((item: MasterSubCategory) => item.code !== '99')
                .map((item: MasterSubCategory) => {
                    return {
                        label: item.codeName,
                        value: item.code,
                    };
                });
            masterDataInit[MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION] =
                masterDataInit[MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION]
                    ?.filter((item: MasterSubCategory) => item.code !== '99')
                    .map((item: MasterSubCategory) => {
                        return {
                            label: item.codeName,
                            value: item.code,
                        };
                    });
            masterDataInit[MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION] = masterDataInit[
                MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION
            ].map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            setMasterData(masterDataInit);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const initiateDefaultData = async (currentStep: number) => {
        try {
            dispatch(startFetching());
            let response = null;
            console.log(currentStep);
            console.log(purchaseOfferId)
            switch (currentStep) {
                case 1: //step 2
                    response = await purchaseUseCase.getDefaultInfoStep2({
                        offerId: offerId ? Number(offerId) : 0,
                    });
                    break;
                case 2: // step 3
                    response = await purchaseUseCase.getDefaultInfoStep3({
                        listed_property_id: listedPropertyId ? Number(listedPropertyId) : 0,
                        purchasePrice: purchasePrice ? Number(purchasePrice) : 0,
                        purchaseOfferId: offerId ? Number(offerId) : 0,
                        procedureId: procedureId ? Number(procedureId) : 0,
                        loanUseStatus: loanUseStatus ? Number(loanUseStatus) : 0,
                    });
                    break;
                default: // step 1
                    response = await purchaseUseCase.getDefaultInfo({
                        offerId: offerId ? Number(offerId) : 0,
                    });
                    break;
            }

            if (response && response.result) {
                const deposit = response.result.deposit
                    ? response.result.deposit / NUMBER_MULTIPLE_DEPOSIT
                    : '';
                const mappingData = {
                    ...response.result,
                    deposit: deposit,
                    simId: simId,
                    includeBrokerageFee: response.result.includeBrokerageFee ? [1] : [0],
                    homePostalCode: response.result.homePostalCode
                        ? response.result.homePostalCode + ''
                        : response.result.postalCode,
                    homeAddress: response.result.homeAddress
                        ? response.result.homeAddress + ''
                        : response.result.address,
                    procedureId: procedureId,
                    purchaseOfferId: offerId,
                    listedPropertyId: listedPropertyId,
                    purchasePrice: purchasePrice,
                    loanUseStatus: loanUseStatus,
                    designatedAddressDiv: response.result.designatedAddressDiv
                        ? response.result.designatedAddressDiv + ''
                        : '',
                    confirm_cic: response.result.agreementOpeDiv01
                        ? response.result.agreementOpeDiv01.split(',')
                        : [],
                    accept_term: response.result.agreementOpeDiv02
                        ? response.result.agreementOpeDiv02.split(',')
                        : [],
                };
                setData(mappingData);
            }
            setIsInit(false);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    useEffect(() => {
        if (!isInit) {
            initiateDefaultData(current);
        }
    }, [current, offerId]);

    const scrollTop = () => {
        document.getElementById('top-form')?.scrollIntoView({ behavior: 'smooth' });
    };

    const { Step } = Steps;

    const render = (step: number) => {
        switch (step) {
            case 1:
                return (
                    <PurchaseStepTwo
                        {...props}
                        setIsChange={setIsChange}
                        data={data}
                        masterData={masterData}
                        current={current}
                        index={2}
                        next={next}
                        prev={prev}
                        scrollTop={scrollTop}
                    />
                );
            case 2:
                return (
                    <PurchaseStepThree
                        {...props}
                        setIsChange={setIsChange}
                        data={data}
                        masterData={masterData}
                        current={current}
                        index={3}
                        next={next}
                        prev={prev}
                        scrollTop={scrollTop}
                    />
                );
            default:
                return (
                    <PurchaseStepOne
                        {...props}
                        setIsChange={setIsChange}
                        setOfferId={setOfferId}
                        data={data}
                        masterData={masterData}
                        current={current}
                        index={1}
                        next={next}
                        prev={prev}
                        scrollTop={scrollTop}
                    />
                );
        }
    };

    const next = () => {
        setIsChange(false);
        setCurrent(current + 1);
    };

    const prev = () => {
        if (isChange) {
            const confirmProps = commonHelpers.getConfirmProps('P001', {
                onOk: () => {
                    setCurrent(current - 1);
                },
            });
            dispatch(showConfirm(confirmProps));
        } else {
            setCurrent(current - 1);
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-015-01-container"
        >
            <PageTitle title="購入申込みフォーム" />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="purchase-form-container w-full md:w-2/3 lg:w-1/2">
                    <Steps current={current} responsive className="w-1/2">
                        {items.map((item, index) => (
                            <Step key={index} status={index === current ? 'process' : 'wait'} />
                        ))}
                    </Steps>
                    <div className="section-wrapper">{render(current)}</div>
                </div>
            </section>
        </div>
    );
};

export default CU01501Page;
